import {ServiceUtil, ServiceUtil as serviceUtil} from "./";
import { ProfileApi } from "./";
import {documentConstants} from "../_constants/documents.constants";



const getDocumentsByUser = async () => {
    let profileInfo = await ProfileApi.getExtendedProfileInfo();
    if(profileInfo.data) {
        const { data } = profileInfo
        return await serviceUtil.executeServiceCall("DocumentAPI",
            `api/Document/UserDocuments`, serviceUtil.postRequest(data.userHash));
    }
}

const getLeadDocumentsByUser = async () => {
    let res = '';
    let profileInfo = await ProfileApi.getExtendedProfileInfo();
    if (profileInfo.data) {
        const { data } = profileInfo
        let searchRequest = {
            "UserId": data.userId,
            "UserHash": data.userHash,
            "UserEmail": data.email
        };
       res = await serviceUtil.executeServiceCall("DocumentAPI",
            `api/Document/Lead`, serviceUtil.postRequest(searchRequest));
    }
    return res;
}

const getFile = async (id) => {
    return await serviceUtil.executeServiceCall("DocumentAPI",
        `api/Document/File/${id}`, serviceUtil.getRequest())
}

const updateDocument = async(document) => {
    return serviceUtil.executeServiceCallAsync("DocumentAPI", 'api/Document/UpdateDocument', serviceUtil.postRequest(document));
}

const getDocumentByIdToken = async (data) => {
    return await serviceUtil.executeServiceCall("DocumentAPI",
        `api/Document/GetDocumentIdByToken`, serviceUtil.postRequest(data))
}
const uploadFile = async (model) => {
    return await fetch("/Document/Upload", serviceUtil.putRequest(model))
    
}
const getDocumentById = async (documentId) =>{
    return await serviceUtil.executeServiceCall("DocumentAPI",
    `api/Document/${documentId}`, serviceUtil.getRequest())
}

const getUploadedUserDocuments = async (userHash) => {
  return await serviceUtil.executeServiceCall(
    "DocumentAPI",
    `api/Document/GetUploadedUserDocuments`,
    serviceUtil.postRequest(userHash)
  );
};


export const DocumentApi = {
    DOCUMENT_CLASSIFICATION_UNKNOWN : 0,
    DOCUMENT_CLASSIFICATION_DONOTUSE_EMPLOYMENT : 1,
    DOCUMENT_CLASSIFICATION_RESIDENCE : 2,
    DOCUMENT_CLASSIFICATION_IDENTITYFRONT : 3,
    DOCUMENT_CLASSIFICATION_IDENTITYBACK : 4,
    DOCUMENT_CLASSIFICATION_INCOME : 5,
    DOCUMENT_CLASSIFICATION_CONTRACTS : 6,
    DOCUMENT_CLASSIFICATION_LETTERS : 7,
    DOCUMENT_CLASSIFICATION_ACHNOTICE : 15,
    DOCUMENT_CLASSIFICATION_LIVECHECKVOIDLETTER : 16,
    DOCUMENT_CLASSIFICATION_LEGAL : 18,
    DOCUMENT_STATUS_NEW: 0,
    DOCUMENT_STATUS_PENDING: 1,
    DOCUMENT_STATUS_UNDERREVIEW: 2,
    DOCUMENT_STATUS_REJECTED: 3,
    DOCUMENT_STATUS_ACCEPTED: 4,
    DOCUMENT_STATUS_NO_APPLICATION_FOUND: 5,
    DOCUMENT_ORIGIN_EMAIL : 0,
    DOCUMENT_ORIGIN_MMS : 1,
    DOCUMENT_ORIGIN_UPLOAD : 2,
    DOCUMENT_ORIGIN_BRUNDAGE : 3,
    DOCUMENT_ORIGIN_ADMIN : 4,
    getDocumentsByUser,
    getLeadDocumentsByUser,
    getFile,
    updateDocument,
    getDocumentByIdToken,
    uploadFile,
    getDocumentById,
    getUploadedUserDocuments
}
